/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'
import { useLoader } from '@react-three/fiber'
import { TextureLoader } from 'three'
import * as THREE from 'three';

export function Islands(props) {
  const { nodes, materials } = useGLTF('https://web-cdn.tankionline.com/new-year/models/islands/islands.glb')
  const lightMap = useLoader(TextureLoader, 'https://web-cdn.tankionline.com/new-year/models/islands/lightmap.png')

  React.useEffect(() => {
    if (!nodes) return
    if (!lightMap) return
    lightMap.flipY = false;
    Object.values(materials).map(mat => {
      mat.lightMap = lightMap;
      mat.lightMapIntensity = 0.8;
      mat.emissiveIntensity = 1;
      mat.map.encoding = THREE.sRGBEncoding;
    })
  }, [nodes, lightMap])

 
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.Final016.geometry} material={materials.IslandWithProps} />
      <mesh geometry={nodes.Final016_1.geometry} material={materials.Islands} />
      <mesh geometry={nodes.Final016_2.geometry} material={materials.ChristmasTree} />
      <mesh geometry={nodes.Final016_3.geometry} material={materials.ChristmassTreeNoAlpha} />
      <mesh geometry={nodes.Final016_4.geometry} material={materials.GiftAtlasB} />
      <mesh geometry={nodes.Final016_5.geometry} material={materials.GiftAtlasA} />
      <mesh geometry={nodes.Final016_6.geometry} material={materials.IslandStart} />
      <mesh geometry={nodes.Final016_7.geometry} material={materials.IslandFinish} />
      <mesh geometry={nodes.Final016_8.geometry} material={materials.Teleport} />
    </group>
  )
}

useGLTF.preload('https://web-cdn.tankionline.com/new-year/models/islands/islands.glb')
